var React = require('react');

function Pixelfed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M500 176q-115 0 -215 58q-96 57 -152 153q-58 99 -58 214.5t58 214.5q56 96 152 152q100 58 215 58t215 -58q96 -56 152 -152q58 -99 58 -214.5t-58 -214.5q-56 -96 -152 -153q-100 -58 -215 -58zM432 435h112q36 0 66.5 17.5t48.5 47t18 65t-18 65t-48.5 47t-66.5 17.5h-78l-111 106v-290q0 -31 22.5 -53t54.5 -22z"}));
}

Pixelfed.defaultProps = {"width":"32px","height":"32px","viewBox":"63 163 875 875","version":"1.1"};

module.exports = Pixelfed;

Pixelfed.default = Pixelfed;
